import { Link } from 'react-router';

export default function SandboxWidgetStep1() {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-2xl font-bold mb-4">Widget Step 1</h2>
      <p className="text-muted-foreground mb-6">
        This is the first step of the widget flow. Fill in your information below.
      </p>
      
      <div className="space-y-4 mb-6">
        <div>
          <label className="block text-sm font-medium mb-2">Name</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-input rounded-md bg-background"
            placeholder="Enter your name"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2">Email</label>
          <input
            type="email"
            className="w-full px-3 py-2 border border-input rounded-md bg-background"
            placeholder="Enter your email"
          />
        </div>
      </div>

      <Link
        to="/sandbox/widget/step-2"
        className="inline-block px-6 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
      >
        Continue to Step 2 →
      </Link>
    </div>
  );
}
